module.exports = __webpack_public_path__ + "img/3.1d8a7f4c.png";